// extracted by mini-css-extract-plugin
module.exports = {"input":"PasswordInput_input__gCVYR","innerInput":"PasswordInput_innerInput__fTaFV","label":"PasswordInput_label__fqMJB","section":"PasswordInput_section__h2Dtp"};